import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-abaf7551.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--ar-AE" */'./ar-AE-31a3341c.js'),
  'de-DE': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--de-DE" */'./de-DE-90b1ec11.js'),
  'en-AU': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--en-AU" */'./en-AU-92ddb69c.js'),
  'en-CA': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--en-CA" */'./en-CA-d5c0075a.js'),
  'en-GB': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--en-GB" */'./en-GB-efd9ae8f.js'),
  'en-IN': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--en-IN" */'./en-IN-29fd6764.js'),
  'en-SG': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--en-SG" */'./en-SG-923816d0.js'),
  'es-CO': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--es-CO" */'./es-CO-ef2b13fd.js'),
  'es-ES': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--es-ES" */'./es-ES-0e07ccfc.js'),
  'es-MX': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--es-MX" */'./es-MX-cf06ad61.js'),
  'es-US': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--es-US" */'./es-US-9617ff35.js'),
  'fr-CA': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--fr-CA" */'./fr-CA-b5b4973f.js'),
  'fr-FR': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--fr-FR" */'./fr-FR-808e6e08.js'),
  'hi-IN': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--hi-IN" */'./hi-IN-a43cd770.js'),
  'it-IT': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--it-IT" */'./it-IT-6e91e46c.js'),
  'ja-JP': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--ja-JP" */'./ja-JP-74d403b2.js'),
  'ko-KR': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--ko-KR" */'./ko-KR-1a7934b3.js'),
  'nl-NL': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--nl-NL" */'./nl-NL-20876972.js'),
  'pl-PL': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--pl-PL" */'./pl-PL-143a65fc.js'),
  'pt-BR': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--pt-BR" */'./pt-BR-d9d4c4a4.js'),
  'sv-SE': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--sv-SE" */'./sv-SE-df28435a.js'),
  'ta-IN': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--ta-IN" */'./ta-IN-9c03a7a5.js'),
  'th-TH': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--th-TH" */'./th-TH-87103804.js'),
  'tr-TR': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--tr-TR" */'./tr-TR-108951f2.js'),
  'vi-VN': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--vi-VN" */'./vi-VN-4bd74e95.js'),
  'zh-CN': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--zh-CN" */'./zh-CN-a0fd4c2e.js'),
  'zh-TW': () => import( /* webpackChunkName: "storm-ui--AbandonmentDialog--zh-TW" */'./zh-TW-cf43b4d0.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-fe39dd40.js.map
